import { ServiceActivityClosedLabel } from '@common/enums';

export function getServiceActivityClosedLabel(type: ServiceActivityClosedLabel) {
    return serviceActivityClosedLabels[type];
}

type ServiceActivityClosedLabels = {
    [Type in ServiceActivityClosedLabel]: string;
};

const serviceActivityClosedLabels: ServiceActivityClosedLabels = {
    [ServiceActivityClosedLabel.ongoing]: 'In behandeling',
    [ServiceActivityClosedLabel.sent]: 'Verstuurd',
    [ServiceActivityClosedLabel.supervised]: 'Gecontroleerd',
    [ServiceActivityClosedLabel.withPatient]: 'Bij patiënt',
};
